import { ISetUpState } from '../../app/set-up/set-up.types';
import { RootState } from '../store';

export const selectSetupModal = (state: RootState): ISetUpState => state.setupModal;
export const selectSetupModalConnector = (state: RootState): ISetUpState['connector'] =>
    state.setupModal.connector;
